export const menuTitle = { title: "MENU", label: "Menu" }
  